import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    variants: {
        active: {
            true: {
                link: 'text-gray-800 font-bold'
            }
        }
    }
} satisfies NuxtUiTheme['breadcrumb'];
